import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'

const MetricCard = ({label, value, subValue, borderColor, valueColor}) => (
  <div
    className='flex-fill me-4 mb-4 rounded px-6 py-5'
    style={{
      border: `2px solid ${borderColor}`,
      minWidth: 180,
      flex: '1 1 180px',
    }}
  >
    <div className='text-gray-500 fw-semibold fs-7 mb-2'>{label}</div>
    <div className='fw-bold fs-2' style={{color: valueColor}}>
      {value}
    </div>
    {subValue && (
      <div className='fw-semibold fs-6 mt-1' style={{color: valueColor, opacity: 0.75}}>
        {subValue}
      </div>
    )}
  </div>
)

MetricCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  subValue: PropTypes.string,
  borderColor: PropTypes.string.isRequired,
  valueColor: PropTypes.string.isRequired,
}

const WorkStatusSummaryCards = ({analysis}) => {
  const intl = useIntl()
  const fmt = (n) =>
    typeof n === 'number' ? n.toLocaleString(undefined, {maximumFractionDigits: 2}) : '—'

  // scheduleStatus: 0 = OnTrack, 1 = Behind, 2 = Ahead
  const isOnTrackOrAhead = analysis.scheduleStatus !== 1
  const statusColor = isOnTrackOrAhead ? '#50cd89' : '#f1416c'
  const statusBorderColor = isOnTrackOrAhead ? '#50cd89' : '#f1416c'

  const statusLabel =
    analysis.scheduleStatus === 0
      ? intl.formatMessage({id: 'WORKSTATUS.STATUS.ONTRACK'})
      : analysis.scheduleStatus === 1
      ? intl.formatMessage(
          {id: 'WORKSTATUS.STATUS.BEHIND'},
          {days: Math.abs(analysis.daysBehindOrAhead)}
        )
      : intl.formatMessage(
          {id: 'WORKSTATUS.STATUS.AHEAD'},
          {days: Math.abs(analysis.daysBehindOrAhead)}
        )

  return (
    <div className='d-flex flex-wrap mb-5'>
      {/* Toplam İş Miktarı — blue */}
      <MetricCard
        label={intl.formatMessage({id: 'WORKSTATUS.CARD.TOTALWORK'})}
        value={intl.formatMessage({id: 'WORKSTATUS.CARD.UNITS'}, {value: fmt(analysis.totalWork)})}
        borderColor='#009ef7'
        valueColor='#009ef7'
      />

      {/* Yapılan İş — orange */}
      <MetricCard
        label={intl.formatMessage({id: 'WORKSTATUS.CARD.COMPLETEDWORK'})}
        value={intl.formatMessage(
          {id: 'WORKSTATUS.CARD.UNITS'},
          {value: fmt(analysis.actualCompletedWork)}
        )}
        subValue={`(${fmt(analysis.overallCompletionRate)}%)`}
        borderColor='#f57544'
        valueColor='#f57544'
      />

      {/* Günlük Hedef — gray */}
      <MetricCard
        label={intl.formatMessage({id: 'WORKSTATUS.CARD.DAILYTARGET'})}
        value={intl.formatMessage(
          {id: 'WORKSTATUS.CARD.UNITS.PER.DAY'},
          {value: fmt(analysis.dailyPlannedWork)}
        )}
        borderColor='#a1a5b7'
        valueColor='#7e8299'
      />

      {/* Durum — red/green */}
      <MetricCard
        label={intl.formatMessage({id: 'WORKSTATUS.CARD.SCHEDULESTATUS'})}
        value={statusLabel}
        borderColor={statusBorderColor}
        valueColor={statusColor}
      />
    </div>
  )
}

WorkStatusSummaryCards.propTypes = {
  analysis: PropTypes.shape({
    totalWork: PropTypes.number,
    actualCompletedWork: PropTypes.number,
    overallCompletionRate: PropTypes.number,
    dailyPlannedWork: PropTypes.number,
    scheduleStatus: PropTypes.number,
    daysBehindOrAhead: PropTypes.number,
  }).isRequired,
}

export {WorkStatusSummaryCards}
